module.exports = __webpack_public_path__ + "static/img/14000552.748a5570.png";